module.exports = __webpack_public_path__ + "img/gas-station.8edafb3c.png";